/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Room_TypeInputs */

const cs_gallery_room_type = /** @type {(inputs: Gallery_Room_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ místnosti`)
};

const en_gallery_room_type = /** @type {(inputs: Gallery_Room_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Room type`)
};

/**
* | output |
* | --- |
* | "Room type" |
*
* @param {Gallery_Room_TypeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_room_type = /** @type {((inputs?: Gallery_Room_TypeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Room_TypeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_room_type(inputs)
	return cs_gallery_room_type(inputs)
});